import { render, staticRenderFns } from "./PersonnelRecordDetailsTabChangelog.vue?vue&type=template&id=3c1debd6"
import script from "./PersonnelRecordDetailsTabChangelog.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDetailsTabChangelog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports